module.exports = __webpack_public_path__ + "media/yicun.bc67d43d.mp4";